import React, { useState } from "react";
import {
  Stack,
  Radio,
  Text,
  Button,
  Modal,
  Group,
  ActionIcon,
  ThemeIcon,
} from "@mantine/core";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { IconShare, IconShareOff, IconEdit } from "@tabler/icons-react";

export default function UserGroupVisibility({
  userGroup,
  editable = false,
  fetchData,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [visibility, setVisibility] = useState(
    userGroup.private ? "private" : "public"
  );
  const isEffortUserGroup = userGroup.report_snapshot_id ? false : true;

  const togglePrivateMutation = useMutation({
    mutationFn: () =>
      axios.post(`/user-groups/${userGroup.id}/toggle-private/`, {
        user_group_id: userGroup.id,
      }),
    onSuccess: () => {
      // toast.success("Visibility updated");
      setIsOpen(false);
      fetchData();
    },
    onError: (err) => {
      toast.error(err);
    },
  });

  return (
    <div>
      <Group gap="xs" align="center" wrap="nowrap">
        <ThemeIcon size="sm" radius="xl" variant="light" color="gray">
          {userGroup.private ? (
            <IconShareOff size={12} />
          ) : (
            <IconShare size={12} />
          )}
        </ThemeIcon>
        <Text size="sm" lineClamp={1}>
          {userGroup.private ? "private" : "public"}
        </Text>
        {editable && (
          <ActionIcon
            size="xs"
            color="gray"
            radius="xl"
            variant="transparent"
            onClick={() => setIsOpen(true)}
          >
            <IconEdit size={14} />
          </ActionIcon>
        )}
      </Group>
      <Modal
        opened={isOpen}
        onClose={() => setIsOpen(false)}
        title="Visibility"
      >
        <Stack gap="sm">
          <Radio
            name="visibility"
            label="Public"
            onChange={() => setVisibility("public")}
            checked={visibility === "public"}
          />
          {visibility === "public" && (
            <Text size="sm" c="gray">
              This group is public and visible to everyone
            </Text>
          )}
          <Radio
            name="visibility"
            label="Private"
            onChange={() => setVisibility("private")}
            checked={visibility === "private"}
            disabled={isEffortUserGroup}
          />
          {visibility === "private" && (
            <Text size="sm" c="gray">
              This group is private and only visible to you
            </Text>
          )}
          {isEffortUserGroup && (
            <Text size="sm" c="yellow">
              Segments from efforts cannot be made private
            </Text>
          )}
          <Button
            onClick={() => togglePrivateMutation.mutate()}
            color="teal"
            size="sm"
            loading={togglePrivateMutation.isPending}
            disabled={isEffortUserGroup}
          >
            Toggle Visibility
          </Button>
        </Stack>
      </Modal>
    </div>
  );
}
